import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { timeFormat } from "../../../utils/utils";
export default {
  name: "DecibelChart",
  methods: {
    timeFormat: timeFormat
  },
  props: {
    decibelLists: {
      type: Array
    },
    startTime: {
      type: [String, Number]
    },
    centerTime: {
      type: [String, Number]
    },
    endTime: {
      type: [String, Number]
    }
  },
  computed: {
    finalLineLists: function finalLineLists() {
      var _this = this;

      var result = [];
      var totalTime = this.endTime - this.startTime; // console.log(totalTime);

      this.decibelLists.forEach(function (item) {
        var leftLength = item.time - _this.startTime; // console.log('item', item.time, this.startTime, leftLength);

        var className = item.decibel <= 30 ? 'line2' : item.decibel <= 40 ? 'line3' : item.decibel <= 50 ? 'line4' : item.decibel <= 60 ? 'line5' : item.decibel <= 70 ? 'line6' : item.decibel <= 80 ? 'line7' : item.decibel <= 90 ? 'line8' : 'line9';
        result.push({
          time: item.time,
          left: leftLength / totalTime * 100,
          value: item.decibel,
          className: className
        });
      }); // console.log('finalLineLists', result)

      return result;
    }
  }
};